type LogoProps = {
  width?: string;
  height?: string;
  opacity?: number;
};

export default function AppLogo(props: Readonly<LogoProps>) {
  const { width = '288px', height = '130px', opacity = 0.6 } = props;
  return <img alt="opapCorpLogo" src="images/opapCorpLogo.png" style={{ width, height, opacity }} />;
}
